module.exports = __webpack_public_path__ + "static/media/implied-future.0541f790.jpg";